<template>
    <div :class="{recommended__event: recommendedEvent}">
        <div class="back_shadow" @click="clickBackdrop"></div>
        <div class="modal_container" :style="style">
            <i class="modal_close_btn" @click="clickBackdrop"></i>
            <div :id="modalId" class="modal_box">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

export default {
    name: "RecommendedModal",
    props: ["modalId", "maxWidth", "height", "recommendedEvent"],
    data() {
        return {
            bodyScrollLockTargetElement: null,
        };
    },
    mounted() {
        this.bodyScrollLockTargetElement = document.querySelector("#" + this.modalId);
        disableBodyScroll(this.bodyScrollLockTargetElement);

        const body = document.querySelector('body');
        body.style.overflow = 'hidden';
    },
    beforeDestroy() {
        enableBodyScroll(this.bodyScrollLockTargetElement);

        const body = document.querySelector('body');
        body.style.removeProperty('overflow');
    },
    methods: {
        clickBackdrop() {
            this.$emit("click-backdrop");
        },
    },
    computed: {
        style() {
            const result = [
                { "max-width": this.maxWidth ? `${this.maxWidth}px` : "initial" },
                ...(this.height ? [{ height: `${this.height}px` }] : []),
            ];
            return result;
        },
    },
};
</script>

<style scoped lang="scss">
.back_shadow {
    position: fixed;
    z-index: 50000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
}

.modal_container {
    display: block;
    z-index: 55000;
    position: fixed;
    top: 50%;
    left: 50%;
    width: 80%;
    height: 80%;
    max-width: 800px;
    border-radius: 14px;
    background-color: #fff;
    transform: translate(-50%, -50%);
}

.modal_box {
    overflow-y: auto;
    height: 100%;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
}

.modal_box::-webkit-scrollbar {
    display: none;
}

.modal_close_btn {
    display: block;
    position: absolute;
    left: 50%;
    top: -37px;
    width: 24px;
    height: 24px;
    background: url(https://dcse8twossp9.cloudfront.net/static/partner/mendini/simplify_pay/ico/close-24-px.svg)
        no-repeat center left;
    transform: translateX(-50%);
    background-color: #fff;
    border-radius: 12px;
    cursor: pointer;
}

.recommended__event{
    .modal_container{
        max-width: 448px !important;
        max-height: calc(448px + 188px);
    }
    .modal_close_btn{
        background-color: unset;
        background-image: url(https://dcse8twossp9.cloudfront.net/static/img/common/header/close-24-px.svg);
        transform: unset;
        top: 12px;
        left: unset;
        right: 24px;
        z-index: 3;
    }
}

@media all and (max-width: 768px) {
    .modal_container {
        top: 70px;
        left: 0;
        width: 100%;
        height: 100% !important;
        transform: translate(0, 0);
        border-radius: 0;
        border-top-left-radius: 14px;
        border-top-right-radius: 14px;
    }

    .modal_box {
        overflow-y: auto;
        height: calc(100% - 60px);
    }

    .recommended__event{
        .modal_container{
            max-height: calc(100vw + 188px);
            top: unset;
            bottom: 0;
            animation-name: modalSlide;
            animation-duration: 0.5s;
        }
        .modal_box{
            height: 100%;
        }
    }
}

@keyframes modalSlide{
    0%{bottom: -100%;}
    100%{bottom: 0;}
}
</style>
